export const CONTACT = 'contact@passwork.ae'
export const ENTITY = 'Passwork FZ LLC'
export const PLACE = 'Ras al Khaimah, United Arab Emirates'
export const PLACE_SHORT = 'Ras al Khaimah, UAE'

/** Sheet corner reference — the real position of Ras al Khaimah. */
export const ORIGIN = '25°47′N 55°57′E'
